module.exports = {
    dialog: {
        tip: 'prompt'
    },
    table: {
        emptyText: 'No Data'
    },
    pagination: {
        pre: 'Previous',
        next: 'Next',
        totalPage: 'Page {cur} of {total}',
        to: 'Go to page',
        page: '',
        sure: 'Go',
        validMsg: {
            inputRule: 'Please enter a positive integer'
        }
    },
    dropdown: {
        menu: 'Drop-down menu',
    },
    errPage: {
        accessError: "Ah~ Can't access this site",
        error404: 'Ah~ The page you visited does not exist',
        backHome: 'Back to home',
        backPre: 'Back to previous page',
        tryMethod: 'Please try the following methods:',
        checkOpt: ['Check the network', 'Check if each service is working properly']
    },
    labelSize: {
        screenInfos: [{
            key: '0001',
            value: '1.54"(152*152) Black White',
            size: '1.54',
            resolution: '152*152',
            rotate: '',
            color: 'black',
            temperature: ''
        }, {
            key: '0002',
            value: '2.13"(212*104) Black White',
            size: '2.13',
            resolution: '212*104',
            rotate: '',
            color: 'black',
            temperature: ''
        }, {
            key: '0003',
            value: '2.13"(250*122) Black White',
            size: '2.13',
            resolution: '250*122',
            rotate: '',
            color: 'black',
            temperature: ''
        }, {
            key: '0004',
            value: '2.9"(296*128) Black White',
            size: '2.9',
            resolution: '296*128',
            rotate: '',
            color: 'black',
            temperature: ''
        }, {
            key: '0005',
            value: '4.2"(400*300) Black White',
            size: '4.2',
            resolution: '400*300',
            rotate: '',
            color: 'black',
            temperature: ''
        }, {
            key: '0006',
            value: '1.54"(152*152) Black White Red',
            size: '1.54',
            resolution: '152*152',
            rotate: '向左旋转90°',
            color: 'red',
            temperature: ''
        }, {
            key: '0007',
            value: '1.54"(152*152) Black White Yellow',
            size: '1.54',
            resolution: '152*152',
            rotate: '向左旋转90°',
            color: 'yellow',
            temperature: ''
        }, {
            key: '0008',
            value: '2.13"(250*122) Black White Red',
            size: '2.13',
            resolution: '250*122',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '0009',
            value: '2.13"(250*122) Black White Yellow',
            size: '2.13',
            resolution: '250*122',
            rotate: '',
            color: 'yellow',
            temperature: ''
        }, {
            key: '000a',
            value: '2.9"(296*128) Black White Red',
            size: '2.9',
            resolution: '296*128',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '000b',
            value: '2.9"(296*128) Black White Yellow',
            size: '2.9',
            resolution: '296*128',
            rotate: '',
            color: 'yellow',
            temperature: ''
        }, {
            key: '000c',
            value: '4.2"(400*300) Black White Red',
            size: '4.2',
            resolution: '400*300',
            rotate: '向左旋转90°',
            color: 'red',
            temperature: ''
        }, {
            key: '000d',
            value: '4.2"(400*300) Black White Yellow',
            size: '4.2',
            resolution: '400*300',
            rotate: '向左旋转90°',
            color: 'yellow',
            temperature: ''
        }, {
            key: '000e',
            value: '2.13"(250*122) Cryogenic Black White',
            size: '2.13',
            resolution: '250*122',
            rotate: '',
            color: 'black',
            temperature: 'low'
        }, {
            key: '000f',
            value: '5.83"(648*480) Black White Red',
            size: '5.83',
            resolution: '648*480',
            rotate: '向左旋转90°',
            color: 'red',
            temperature: ''
        }, {
            key: '0010',
            value: '7.5"(880*528) Black White Red',
            size: '7.5',
            resolution: '880*528',
            rotate: '向左旋转90°',
            color: 'red',
            temperature: ''
        }, {
            key: '0011',
            value: '2.66"(296*152) Black White Red',
            size: '2.66',
            resolution: '296*152',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '0012',
            value: '1.54"(200*200) Black White Red',
            size: '1.54',
            resolution: '200*200',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '0013',
            value: '2.13"(250*122) Black White Red',
            size: '2.13',
            resolution: '250*122',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '0014',
            value: '2.9"(296*128) Black White Red',
            size: '2.9',
            resolution: '296*128',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '0015',
            value: '4.2"(400*300) Black White Red',
            size: '4.2',
            resolution: '400*300',
            rotate: '',
            color: 'red',
            temperature: ''
        },{
            key: '0017',
            value: '11.6"(960*640) Black White Red',
            size: '11.6',
            resolution: '960*640',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '8000',
            value: 'Screen damage',
            size: '',
            resolution: '',
            rotate: '',
            color: '',
            temperature: ''
        }]
    },
    allLabelTypeDatas: [{ //树形组件  标签条件查询
            id: '1.54_a',
            label: '1.54 "',
            children: [{
                id: '1.54_b',
                label: '1.54" Black White'
            }, {
                id: '1.54_r',
                label: '1.54" Black White Red'
            }, {
                id: '1.54_y',
                label: '1.54" Black White Yellow'
            }]
        }, {
            id: '2.13_a',
            label: '2.13"',
            children: [{
                id: '2.13_b',
                label: '2.13" Black White'
            }, {
                id: '2.13_r',
                label: '2.13" Black White Red'
            }, {
                id: '2.13_y',
                label: '2.13" Black White Yellow'
            }, {
                id: '2.13_b_low',
                label: '2.13" Cryogenic Black White'
            }]
        },
         {
            id: '2.66_a',
            label: '2.66"',
            disabled: true,
            children: [{
                id: '2.66_b',
                label: '2.66" Black White',
                disabled: true
            }, {
                id: '2.66_r',
                label: '2.66" Black White Red'
            }, {
                id: '2.66_y',
                label: '2.66" Black White Yellow',
                disabled: true
            }]
        },
        {
            id: '2.9_a',
            label: '2.9"',
            children: [{
                id: '2.9_b',
                label: '2.9" Black White'
            }, {
                id: '2.9_r',
                label: '2.9" Black White Red'
            }, {
                id: '2.9_y',
                label: '2.9" Black White Yellow'
            }]
        }, {
            id: '4.2_a',
            label: '4.2"',
            children: [{
                id: '4.2_b',
                label: '4.2" Black White'
            }, {
                id: '4.2_r',
                label: '4.2" Black White Red'
            }, {
                id: '4.2_y',
                label: '4.2" Black White Yellow'
            }]
        }, {
            id: '5.83_a',
            label: '5.83"',
            disabled: true,
            children: [{
                id: '5.83_b',
                label: '5.83" Black White',
                disabled: true
            }, {
                id: '5.83_r',
                label: '5.83" Black White Red',
                // disabled: true
            }, {
                id: '5.83_y',
                label: '5.83" Black White Yellow',
                disabled: true
            }]
        }, {
            id: '7.5_a',
            label: '7.5"',
            disabled: true,
            children: [{
                id: '7.5_b',
                label: '7.5" Black White',
                disabled: true
            }, {
                id: '7.5_r',
                label: '7.5" Black White Red',
                // disabled: true
            }, {
                id: '7.5_y',
                label: '7.5" Black White Yellow',
                disabled: true
            }]
        }, {
            id: '11.6_a',
            label: '11.6"',
            disabled: true,
            children: [{
                id: '11.6_b',
                label: '11.6" Black White',
                disabled: true
            }, {
                id: '11.6_r',
                label: '11.6" Black White Red',
                // disabled: true
            }, {
                id: '11.6_y',
                label: '11.6" Black White Yellow',
                disabled: true
            }]
        }
    ],
    // excelComment: 'Barcode length is fixed to 13 digits',
    // excelComment: 'ID consists of letters or numbers',
    excelComment: {
        id: 'ID consists of letters or numbers',
        qrcode: 'The QR code system will be automatically generated according to the ID, no need to fill in; if filled in, still use the system automatically generated QR code'
    },
    labelPreview: {
        loadErr: 'Failed to load image',
        chooseImg: 'Please select an image to draw',
        brErr: 'Please enter a number or letter for the barcode, otherwise it will not be displayed',
        brErr1: 'Please enter 13 digits for the barcode, otherwise it will not be displayed'
    },
    viewPermis: {
        demo: 'You do not have permission to view the template related pages of this store',
        editDemo: 'You do not have permission to edit the store\'s template',
        sysDemo: 'You do not have permission to view system template related pages',
        system: 'You do not have permission to view system pages',
        errcode: 'You do not have permission to view the error code page',
        shopSetting: 'You do not have permission to view the store\'s settings page',
        hasStore: 'You are not a member of the store and cannot view the store data, please contact the administrator to assign the store for you',
        storeClose: 'The store you viewed is closed'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/common.js